<template>
  <div class="order-manage">
    <div>
      <h2>订单管理</h2>
      <div class="search-area">
        <el-input placeholder="搜索订单号/商品/买家" prefix-icon="el-icon-search" v-model="searchForm.keyword"
          class="search-input" @change="changeValue()"></el-input>
        <div class="date-filter">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期范围" v-model="searchForm.startTime"
            class="date-picker"></el-date-picker>

          <span class="date-separator">至</span>

          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期范围" v-model="searchForm.endTime"
            class="date-picker"></el-date-picker>
        </div>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">搜索</el-button>
        <el-button type="primary" plain @click="handleExport" class="export-btn">下载明细</el-button>
      </div>

      <div class="order-tabs">
        <el-tabs v-model="searchForm.status" @tab-click="handleClick">
          <el-tab-pane :label="`待发货 (${pendingShipment})`" name="2"></el-tab-pane>
          <el-tab-pane :label="`已发货 (${shipped})`" name="3"></el-tab-pane>
          <el-tab-pane :label="`已收货 (${successful})`" name="4"></el-tab-pane>
          <el-tab-pane :label="`待付款 (${waitPay})`" name="1"></el-tab-pane>
          <el-tab-pane :label="`已取消 (${closed})`" name="0"></el-tab-pane>
        </el-tabs>
      </div>

      <div class="order-table">
        <el-table :data="mergedData" :span-method="spanMethod" border :cell-style="{ borderColor: '#EBEEF5' }"
          :header-cell-style="{ borderColor: '#EBEEF5', backgroundColor: '#F5F7FA' }">
          <el-table-column label="商品信息" align="center">
            <template slot-scope="scope">
              <!-- 订单信息 -->
              <div v-if="scope.row.type === 'order'" class="order">

                <div>
                  <span>{{ scope.row.orderItemId }}<br></span>
                  <span>{{ scope.row.createTime }}</span>
                </div>
                <div>
                  <span>{{ scope.row.identityName }}<br></span>
                  <span>{{ scope.row.phone }}</span>
                </div>
                <div><span>{{ scope.row.status }}</span> <br></div>
                <div>
                  <span>合计{{ scope.row.goodsPrice }} <br></span>
                  <span>(包含邮费{{ scope.row.mailPrice ? scope.row.mailPrice : 0 }}元)</span>
                </div>
                <div>
                  <el-button type="text" @click="checkOrder(scope.row)">查看</el-button>
                  <el-button type="primary" size="mini" v-if="scope.row.orderStatus == '2'" @click="sendHandOrder(scope.row)">填写快递单号</el-button>
                  <el-button type="primary" size="mini" v-if="scope.row.orderStatus == '2'" @click="sendOrder(scope.row)">在线发货</el-button>
                </div>
              </div>
              <!-- 商品信息 -->
              <!-- <div v-else>{{ scope.row.product }}</div> -->
              <div v-else class="product-info">
                <img :src="scope.row.newImg" alt="" class="product-image" />

                <div class="product-detail">
                  <div class="product-name-ellipsis" :title="scope.row.goodsName">
                    {{ scope.row.goodsName }}
                  </div>
                  <div class="product-spec">{{ scope.row.specificationValue }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="price" label="单价" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.type !== 'order'">￥{{ scope.row.price }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="quantity" label="数量" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.type !== 'order'">{{ scope.row.num }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="总价" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.type !== 'order'">{{ scope.row.totalPrice }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination">
        <span class="total-info">显示 {{ query.pageNum }} 到 {{ query.pageSize }} 条，共 {{ total }} 条</span>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="query.pageNum"
          :page-size="query.pageSize" @current-change="handlePageChange">
        </el-pagination>
      </div>

      <!-- 添加订单详情弹窗 -->
      <el-dialog title="订单详情" :visible.sync="dialogVisible" width="30%" center>
        <div class="order-detail">
          <div class="detail-item">
            <span class="label">订单编号：</span>
            <span class="value">{{ currentOrder.shopId }}</span>
          </div>
          <div class="detail-item">
            <span class="label">下单时间：</span>
            <span class="value">{{ currentOrder.createTime }}</span>
          </div>
          <div class="detail-item">
            <span class="label">收货人：</span>
            <span class="value">{{ currentOrder.identityName }}</span>
            <el-button size="mini" class="copy-btn" @click="copyUserInfo">复制信息</el-button>
          </div>
          <div class="detail-item">
            <span class="label">收货地址：</span>
            <span class="value">{{ currentOrder.address ? currentOrder.address.address : '暂无数据' }}</span>
          </div>

          <div class="detail-item">
            <span class="label">收货电话：</span>
            <span class="value">{{ currentOrder.phone }}</span>
          </div>

          <div class="detail-item" v-if="currentOrder.orderStatus == '3' || currentOrder.orderStatus == '4'">
            <span class="label">物流公司：</span>
            <span class="value">{{ currentOrder.shipCompanyName ? currentOrder.shipCompanyName : '' }}</span>
          </div>

          <div class="detail-item" v-if="currentOrder.orderStatus == '3' || currentOrder.orderStatus == '4'">
            <span class="label">快递单号：</span>
            <span class="value">{{ currentOrder.shipNum ? currentOrder.shipNum : '' }}</span>
          </div>

          <div class="detail-item">
            <span class="label">商品：</span>
            <div v-if="currentOrder.orderProductList && currentOrder.orderProductList.length > 0" class="product-list">
              <div v-for="(product, index) in currentOrder.orderProductList" :key="index" class="product-container">
                <img :src="product.goodsImg && Array.isArray(product.goodsImg) && product.goodsImg[0] && product.goodsImg[0].url
                  ? `${baseUrl}admin/file/get?ossFilePath=${product.goodsImg[0].url}`
                  : ''" class="product-img" />
                <div class="product-name">
                  {{ product.specificationValue }}

                  <!-- {{ product.productName || currentOrder.productName }} *
                      {{ product.productSpec && product.productSpec.split('×')[1] ? product.productSpec.split('×')[1].trim() :
                      '1件' }} -->
                </div>
                <!-- <div class="product-tag" v-if="product.productSpec && product.productSpec.includes('包')">
                      {{ product.productSpec.split('×')[0].trim() }}
                    </div> -->
              </div>
            </div>
            <div v-else class="product-container">
              <img :src="currentOrder.productImage && Array.isArray(currentOrder.productImage) && currentOrder.productImage[0] && currentOrder.productImage[0].url
                ? `${baseUrl}admin/file/get?ossFilePath=${currentOrder.productImage[0].url}`
                : ''" class="product-img" />
              <div class="product-name">{{ currentOrder.productName }} * {{ currentOrder.productSpec &&
                currentOrder.productSpec.split('×')[1] ? currentOrder.productSpec.split('×')[1].trim() : '1件' }}</div>
              <div class="product-tag" v-if="currentOrder.productSpec && currentOrder.productSpec.includes('包')">
                {{ currentOrder.productSpec.split('×')[0].trim() }}</div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="footer-left">
            <el-button icon="el-icon-chat-dot-round" @click="handleChat(currentOrder)" class="chat-btn">在线沟通</el-button>
          </div>
          <div class="footer-right">
            <el-button @click="dialogVisible = false">关闭</el-button>
            <!-- <el-button type="primary" @click="handleSend">发货</el-button> -->
          </div>
        </div>
      </el-dialog>

      <!-- 添加发货弹窗 -->
      <el-dialog title="订单详情" :visible.sync="shipDialogVisible" width="30%" center>
        <div class="order-detail">
          <div class="detail-item">
            <span class="label">订单编号：</span>
            <span class="value">{{ currentOrder.shopId }}</span>
          </div>
          <div class="detail-item">
            <span class="label">下单时间：</span>
            <span class="value">{{ currentOrder.createTime }}</span>
          </div>
          <div class="detail-item">
            <span class="label">收货人：</span>
            <span class="value">{{ currentOrder.identityName }}</span>
            <el-button size="mini" class="copy-btn" @click="copyUserInfo">复制信息</el-button>
          </div>
          <div class="detail-item">
            <span class="label">收货地址：</span>
            <span class="value">{{ currentOrder.address ? currentOrder.address.address : '暂无数据' }}</span>
          </div>
          <!-- <div class="detail-item">
                <span class="label">收货编号：</span>
                <span class="value">{{ currentOrder.addressCode || '邮编(087-201)' }}</span>
              </div> -->
          <div class="detail-item">
            <span class="label">收货电话：</span>
            <span class="value">{{ currentOrder.phone }}</span>
          </div>
          <div class="detail-item">
            <span class="label">商品：</span>
            <div v-if="currentOrder.orderProductList && currentOrder.orderProductList.length > 0" class="product-list">
              <div v-for="(product, index) in currentOrder.orderProductList" :key="index" class="product-container">
                <img :src="product.goodsImg && Array.isArray(product.goodsImg) && product.goodsImg[0] && product.goodsImg[0].url
                  ? `${baseUrl}admin/file/get?ossFilePath=${product.goodsImg[0].url}`
                  : ''" class="product-img" />
                <div class="product-name">
                  {{ product.specificationValue }}
                  <!-- {{ product.productName || currentOrder.productName }} *
                      {{ product.productSpec && product.productSpec.split('×')[1] ? product.productSpec.split('×')[1].trim() :
                      '1件' }} -->
                </div>
                <div class="product-tag" v-if="product.productSpec && product.productSpec.includes('包')">
                  {{ product.productSpec.split('×')[0].trim() }}
                </div>
              </div>
            </div>
            <div v-else class="product-container">
              <img :src="currentOrder.productImage && Array.isArray(currentOrder.productImage) && currentOrder.productImage[0] && currentOrder.productImage[0].url
                ? `${baseUrl}admin/file/get?ossFilePath=${currentOrder.productImage[0].url}`
                : ''" class="product-img" />
              <div class="product-name">{{ currentOrder.productName }} * {{ currentOrder.productSpec &&
                currentOrder.productSpec.split('×')[1] ? currentOrder.productSpec.split('×')[1].trim() : '1件' }}</div>
              <div class="product-tag" v-if="currentOrder.productSpec && currentOrder.productSpec.includes('包')">
                {{ currentOrder.productSpec.split('×')[0].trim() }}</div>
            </div>
          </div>

          <!-- 快递信息填写区域 -->
          <div class="shipping-info" v-if="isOnlineDeliver == '1'">
            <div class="detail-item">
              <span class="label"><span class="red-star">*</span>快递公司：</span>
              <el-select v-model="form.logisticsCompanyId" placeholder="请选择快递公司" class="shipping-select" @change="handleLogisticsChange">
                <el-option v-for="item in shippingCompanies" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="detail-item">
              <span class="label"><span class="red-star">*</span>寄件信息：</span>
              <div v-if="displayAddress" @click="editAddress('edit')" class="delivery-address"
                style="cursor:pointer; color:#409EFF; margin-top:8px;">
                {{ displayAddress.userName }},{{ displayAddress.phone }},{{ displayAddress.address }}
                <i class="el-icon-edit" style="margin-left:4px;"></i>
              </div>
              <div v-else>
                <el-button type="primary" size="mini" @click="editAddress('add')" style="margin-top:8px;">新增寄件地址</el-button>
              </div>
            </div>
            <div class="detail-item">
              <span class="label"><span class="red-star">*</span>账户：</span>
              <el-input v-model="form.partnerId" placeholder="请输入电子面单账户或月结账号" class="weight-input"></el-input>
            </div>
            <div class="detail-item">
              <span class="label"><span class="red-star">*</span>物品名称：</span>
              <el-input v-model="form.itemName" placeholder="请输入物品名称" class="weight-input"></el-input>
            </div>
            <div class="detail-item">
              <span class="label"><span class="red-star">*</span>包裹总数量：</span>
              <el-input v-model="form.count" placeholder="请输入包裹总数量" class="weight-input"></el-input>
            </div>
            <div class="detail-item">
              <span class="label">支付方式：</span>
              <el-select v-model="form.payType" placeholder="请选择支付方式" class="weight-input">
                <el-option v-for="item in payTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <!-- <div class="detail-item">
              <span class="label">商品重量：</span>
              <el-input v-model="form.weight" placeholder="请输入重量" class="weight-input"></el-input>
            </div> -->
            <div class="detail-item">
              <span class="label">备注：</span>
              <el-input v-model="form.remark" placeholder="请输入备注" class="remark-input"></el-input>
            </div>
          </div>
          <div v-else>
            <div class="detail-item">
              <span class="label"><span class="red-star">*</span>快递公司：</span>
              <el-select v-model="form.logisticsCompanyId" placeholder="请选择快递公司" class="shipping-select">
                <el-option v-for="item in shippingCompanies" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="detail-item">
              <span class="label"><span class="red-star">*</span>快递编号：</span>
              <el-input v-model="logisticsNumber" placeholder="请输入快递编号" class="weight-input"></el-input>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="footer-left">
            <el-button icon="el-icon-chat-dot-round" @click="handleChat(currentOrder)" class="chat-btn">在线沟通</el-button>
          </div>
          <div class="footer-right">
            <el-button @click="shipDialogVisible = false">关闭</el-button>
            <el-button type="primary" @click="confirmShipment">确认发货</el-button>
          </div>
        </div>
      </el-dialog>
    </div>


    <!-- 修改地址列表弹窗 -->
    <editAddressDialog :visible.sync="editAddressDialogVisible" :mySelfAddress.sync="mySelfAddress"
      @select="handleSelectAddress" />
    <!-- 新增地址弹窗 -->
    <!-- :regionOptions="regionOptions" -->
    <addAddress :visible.sync="addAddressDialogVisible" @save="handleAddAddress" />

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SendMessage } from "@/api/websocket";
import { selectPcOrderPageList, detail, selectShipCompany, deliverGoods, getPcOrderNumber, addressList, getPartnerIdByShipCompanyId } from '@/api/sjzx'
import editAddressDialog from '../../../memberCenter/nzfw/components/editAddressDialog.vue'
import addAddress from '../../../memberCenter/nzfw/components/addAddress.vue'

export default {
  name: 'orderManage',
  data() {
    return {
      baseUrl: window.globalUrl.HOME_API,
      query: {
        pageNum: 1,
        pageSize: 10,
      },
      searchForm: {
        keyword: '',//输入搜索框
        startTime: '',//开始时间
        endTime: '',//结束时间
        status: '2'//切换状态

      }, //搜索
      searchInput: '',
      startDate: '',
      endDate: '',
      status: '',//切换的列表
      currentPage: 1,
      dialogVisible: false,
      shipDialogVisible: false,
      currentOrder: {},
      payTypeList: [
        { value: 'SHIPPER', label: '寄方付' },
        { value: 'CONSIGNEE', label: '到付' },
        { value: 'MONTHLY', label: '月结' },
        { value: 'THIRDPARTY', label: '第三方支付' },
      ],
      form: {
        // courierNumber: '',////快递单号
        logisticsCompanyId: '',////物流公司id
        orderItemId: '',//子订单号
        sendAddressId: '',//寄件人地址id
        partnerId: '',//电子面单账户或月结账号
        itemName: '',//物品名称
        payType: 'MONTHLY', //支付方式  SHIPPER：寄方付（默认） CONSIGNEE：到付 MONTHLY：月结 THIRDPARTY：第三方支付
        count: 1,
        // weight: '',//重量
        remark: '',//备注
      },
      isOnlineDeliver: '1', //是否在线发货 0否 1是
      logisticsNumber: '', // Kuaidi快递单号

      trackingNumber: '',
      shippingCompanies: [
        { value: 'SF', label: '顺丰快递' },
        { value: 'YTO', label: '圆通快递' },
        { value: 'ZTO', label: '中通快递' },
        { value: 'STO', label: '申通快递' },
        { value: 'YD', label: '韵达快递' },
        { value: 'EMS', label: 'EMS快递' },
        { value: 'HTKY', label: '百世快递' }
      ],
      tableData: [],
      total: 0,
      pendingShipment: 0,//代发货
      shipped: 0,//已发货
      successful: 0,//已成功
      refunding: 0,//退款中
      closed: 0,//已关闭
      waitPay: 0,//待付款
      selectedAddress: null, // 当前选中的地址
      mySelfAddress: [], // 用户地址列表
      editAddressDialogVisible: false, // 编辑地址弹窗显示
      addAddressDialogVisible: false, // 新增地址弹窗显示
    }
  },
  created() {
    // this.getIsHave()
  },
  computed: {
    ...mapGetters(["identityObj"]),
    // 重组数据：插入订单信息行
    mergedData() {
      console.log(this.tableData, '查看this.tableData')
      return this.tableData.flatMap(order => [
        { type: "order", ...order }, // 插入订单行
        ...order.orderProductList.map(p => ({ type: "product", ...p })), // 插入商品行
      ]);
    },

    // 计算属性：用于显示的地址，优先选中地址，否则取默认地址，否则取第一个地址
    displayAddress() {
      console.log(this.selectedAddress, '查看this.selectedAddress')
      if (this.selectedAddress) return this.selectedAddress;
      return this.mySelfAddress.find(addr => addr.defaultFlag === '1') || this.mySelfAddress[0] || null;
    },

  },
  components: { editAddressDialog, addAddress },
  mounted() {
    this.getSelectPcOrderPageList()
    this.getSelectShipCompany()
    this.getPcOrderNumber()
    this.getAddressInfo()
  },
  methods: {
    //判断是草稿还是保存
    // getIsHave() {
    //   //0保存，1草稿

    //   // let identityObj = localStorage.getItem("identityObj") || []
    //   // 从本地存储加载草稿
    //   const draft = localStorage.getItem('identityObj')
    //   if (draft) {
    //     try {
    //       const identityObj = JSON.parse(draft)
    //       if (identityObj) {
    //         // let obj = JSON.parse(identityObj)
    //         this.IsHaveobj = identityObj.content.shop.draftFlag == null ? false : identityObj.content.shop.draftFlag == 0 ? true : false
    //         console.log(this.IsHave, '查看this.IsHave')
    //       }
    //     } catch (e) {
    //       console.error('解析草稿数据失败', e)
    //     }
    //   }

    // },
    // 获取商家地址信息
    async getAddressInfo() {
      this.loading = true;
      try {
        const res = await addressList();
        this.mySelfAddress = res.data.records || [];
        if (!this.selectedAddress) {
          this.selectedAddress = this.mySelfAddress.find(addr => addr.defaultFlag === '1') || this.mySelfAddress[0] || null;
        }
        console.log(this.selectedAddress, '查看获取的收货地址')
      } catch (e) {
        this.$message.error('获取地址失败');
      } finally {
        this.loading = false;
      }
    },

    // 编辑或新增地址弹窗
    editAddress(mode) {
      if (mode === 'edit') {
        this.editAddressDialogVisible = true;
      } else if (mode === 'add') {
        this.addAddressDialogVisible = true;
      }
    },

    // 新增地址后刷新地址列表
    handleAddAddress() {
      this.getAddressInfo()
    },
    // 选择地址
    handleSelectAddress(address) {
      console.log(address, '查看获取的address');
      this.selectedAddress = address;
    },

    //订单管理
    async getPcOrderNumber() {
      let params = {
        ... this.query,
        ...this.searchForm,
      }

      let res = await getPcOrderNumber(params)
      console.log(res, '查看res')
      let { pendingShipment, shipped, successful, refunding, closed, waitPay } = res.data
      this.pendingShipment = pendingShipment
      this.shipped = shipped
      this.successful = successful
      this.refunding = refunding
      this.closed = closed
      this.waitPay = waitPay
    },
    open() {
      //跳转注册页面路由
      this.$router.push({ name: "supplierRegistration" });
    },
    handleExport() {
      // 导出明细处理逻辑
      // console.log('导出明细')
    },
    async checkOrder(order) {
      // 查看订单处理逻辑
      // this.currentOrder = order;
      // console.log('查看订单', order)
      let params = {
        orderItemId: order.orderItemId
      }
      let res = await detail(params)
      res.data.orderProductList.forEach(item => {
        item.goodsImg = JSON.parse(item.goodsImg)
      })
      this.currentOrder = res.data
      this.dialogVisible = true;
      // console.log('查看订单', order);
    },
    async sendOrder(order) {
      // 发货处理逻辑
      // this.currentOrder = order;
      // this.shippingCompany = '';
      // this.trackingNumber = '';
      // this.shipDialogVisible = true;
      // console.log('发货', order);
      let params = {
        orderItemId: order.orderItemId
      }
      let res = await detail(params)
      res.data.orderProductList.forEach(item => {
        item.goodsImg = JSON.parse(item.goodsImg)
      })
      if (res.code == 0) {
        this.currentOrder = res.data
        this.form.itemName = res.data.orderProductList[0].goodsName
        this.shipDialogVisible = true;
        this.isOnlineDeliver = '1';
        this.getSelectShipCompany(order.orderItemId)
      }

    },
    async sendHandOrder(order) {
      let params = {
        orderItemId: order.orderItemId
      }
      let res = await detail(params)
      res.data.orderProductList.forEach(item => {
        item.goodsImg = JSON.parse(item.goodsImg)
      })
      if (res.code == 0) {
        this.currentOrder = res.data
        this.shipDialogVisible = true;
        this.isOnlineDeliver = '0';
        this.getSelectShipCompany(order.orderItemId)
      }
    },
    handlePageChange(page) {
      this.currentPage = page
      // 加载对应页数据
      // console.log('切换到页码', page)
    },
    handleSend() {
      // 关闭查看弹窗，打开发货弹窗
      this.dialogVisible = false;
      this.sendOrder(this.currentOrder);
    },

    copyUserInfo() {
      // 构建要复制的信息
      // const info = `收货人：${this.currentOrder.buyerName || ''}\n收货地址：${this.currentOrder.address || '东莞市南城区下手车街道'}\n收货编号：${this.currentOrder.addressCode || '邮编(087-201)'}\n收货电话：${this.currentOrder.buyerPhone || ''}`;
      const info = `收货人：${this.currentOrder.identityName}收货地址：${this.currentOrder.address ? this.currentOrder.address.address : '暂无数据'}收货电话：${this.currentOrder.phone}`
      // 创建临时文本区域
      const textarea = document.createElement('textarea');
      textarea.value = info;
      document.body.appendChild(textarea);
      textarea.select();

      try {
        // 执行复制命令
        document.execCommand('copy');
        this.$message({
          message: '收货信息复制成功',
          type: 'success'
        });
      } catch (err) {
        this.$message.error('复制失败');
      } finally {
        // 移除临时文本区域
        document.body.removeChild(textarea);
      }
    },

     async handleLogisticsChange(companyId) {
        if (!companyId) return;

        const res = await getPartnerIdByShipCompanyId({
          shipCompanyId: companyId
        });
        if (res.code === 0) {
          this.form.partnerId = res.data || ''; // 清空之前的选择
        }else {
          this.form.partnerId = '';
        }
      },

    async getPartnerIdByShipCompanyId(data) {
      let res = await getPartnerIdByShipCompanyId(data);
      if (res.code == 0) {
        this.form.partnerId = res.data.partnerId
      }
    },

    async confirmShipment() {
      // console.log(this.currentOrder, '查看this.currentOrder')
      // 发货
      if (!this.form.logisticsCompanyId) {
        this.$message.warning('请选择快递公司');
        return;
      }

      if (this.isOnlineDeliver == '1') {
        let params = {
          ...this.form,
          sendAddressId: this.selectedAddress.id,
          orderItemId: this.currentOrder.id,
          isOnlineDeliver: '1'
        }

        // console.log(params, '查看params')
        let res = await deliverGoods(params)

        if (res.code == 0) {
          this.shipDialogVisible = false;
          this.currentOrder = [],
          this.form = {}
          this.getSelectPcOrderPageList()
          this.getPcOrderNumber()
          this.$message.success(res.msg)
        } else {
          this.$message.info(res.msg)
        }
      } else {
        let params = {
          logisticsCompanyId: this.form.logisticsCompanyId,
          isOnlineDeliver: '0',
          courierNumber: this.logisticsNumber,
          orderItemId: this.currentOrder.id
        }
        let res = await deliverGoods(params)
        console.log(params, '查看params')
        if (res.code == 0) {

          this.shipDialogVisible = false;
          this.currentOrder = [],
          this.form = {}
          this.getSelectPcOrderPageList()
          this.getPcOrderNumber()
          this.$message.success(res.msg)
        } else {
          // this.shipDialogVisible = false;
          this.$message.info(res.msg)
        }
      }



    },
    //控制层
    handleSearch() {
      // 搜索处理逻辑
      this.getSelectPcOrderPageList()
      this.getPcOrderNumber()
    },
    handleClick(tab, event) {
      //切换列表
      this.getSelectPcOrderPageList()
      this.getPcOrderNumber()
    },
    async handleChat(item) {
      // 在线沟通处理逻辑
      // console.log('在线沟通', item);
      let params = {
        messageList: [
          {
            //消息类型会话托管
            messageType: 0,
            content: "",
          },
        ],
        senderType: this.identityObj.identityTypeCode,
        senderId: this.identityObj.identityId,
        sender: this.identityObj.realName,
        receiverType: item.identityType,
        receiver: item.identityName,
        receiverId: item.identityId,
      }
      let res = await SendMessage(params);
      if (res.code == 0) {
        this.$router.push({
          path: "/home/Chat",
          // query: {
          //   isshow: false, // 你要传递的参数
          //   data: {
          //     type: true,
          //     identityId: item.id
          //   },
          //   num: 0,
          // },
        });
      }
    },
    changeValue() {
      //搜索商品
      this.getSelectPcOrderPageList()
    },
    //数据层
    async getSelectShipCompany(id) {
      //快递公司列表
      // let params = {
      //   orderItemId: id
      // }
      let res = await selectShipCompany()
      if (res.code == 0) {
        this.shippingCompanies = res.data
      }

    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // 合并单元格逻辑
      if (row.type === "order") {
        // 订单行：合并所有列（独占一行）
        if (columnIndex === 0) {
          return { rowspan: 1, colspan: 4 }; // 合并3列
        } else {
          return { rowspan: 0, colspan: 0 }; // 其他列不显示
        }
      }
    },
    changeList(arr) {
      arr.forEach(item => {
        item.orderProductList.forEach(its => {
          try {
            const imgs = JSON.parse(its.goodsImg);
            console.log(imgs, '查看imgs');
            if (Array.isArray(imgs) && imgs.length > 0 && imgs[0] && imgs[0].url) {
              its.newImg = this.baseUrl + 'admin/file/get?ossFilePath=' + imgs[0].url;
            } else {
              its.newImg = ''; // 或者给个默认图片
            }
          } catch (error) {
            console.error('解析JSON字符串时出错:', error);
            // its.newImg = ''; // 或者给个默认图片
          }
        });
      });
      // console.log(arr,'查看arr')
      return arr;
    },
    async getSelectPcOrderPageList() {
      //获取订单列表
      let params = {
        ... this.query,
        ...this.searchForm,
        // status: this.status
      }
      let res = await selectPcOrderPageList(params)
      this.tableData = this.changeList(res.data.records)
      console.log(this.tableData, '查看this.tableData')
      this.total = Number(res.data.total)
      // console.log(res.data.pendingShipment, '查看pendingShipment')
      // this.pendingShipment = res.data.pendingShipment || 0
      // this.shipped = res.data.shipped || 0
      // this.Integersuccessful = res.data.Integersuccessful || 0
      // this.refunding = res.data.refunding || 0
      // this.closed = res.data.closed || 0
    }
  }
}

</script>

<style lang="less" scoped>
.order-manage {
  padding: 20px;
  background-color: #fff;

  h2 {
    font-size: 18px;
    margin-bottom: 20px;
    font-weight: bold;
  }

  .search-area {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .search-input {
      width: 320px;
      margin-right: 10px;
    }

    .date-filter {
      display: flex;
      align-items: center;
      margin-right: 10px;

      .date-picker {
        width: 150px;
      }

      .date-separator {
        margin: 0 10px;
        color: #606266;
      }
    }

    .el-button {
      margin-left: 10px;
    }

    .search-btn {
      background-color: #409EFF;
      border-color: #409EFF;
    }

    .export-btn {
      color: #409EFF;
      background-color: white;
      border-color: #409EFF;
    }
  }

  .order-tabs {
    margin-bottom: 20px;
    border-bottom: 1px solid #e6e6e6;
  }

  .order-table {
    .order {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-around;
      align-items: center;
      text-align: center;
      /* background-color: #ccc; */
    }

    margin-bottom: 20px;

    .order-number {
      font-weight: bold;
      margin-bottom: 5px;
    }

    .order-date {
      font-size: 12px;
      color: #999;
    }

    .buyer-info,
    .product-info {

      display: flex;
      justify-content: center;
      align-items: center;

      .buyer-avatar,
      .product-image {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }

      .product-image {
        border-radius: 4px;
      }

      .buyer-detail,
      .product-detail {
        font-size: 14px;

        .product-spec {
          font-size: 12px;
          color: #999;
          margin-top: 5px;
        }

        .product-count {
          font-size: 12px;
          color: #409EFF;
          margin-top: 5px;
        }
      }
    }

    .price {
      font-weight: bold;
    }

    .price-tag {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }

    .discount {
      font-size: 12px;
      color: #ff6700;
      margin-top: 5px;
    }

    .children-products {
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px dashed #EBEEF5;
    }

    .child-product-info {
      display: flex;
      align-items: center;
      margin-top: 8px;

      .child-product-image {
        width: 30px;
        height: 30px;
        border-radius: 4px;
        margin-right: 8px;
      }

      .child-product-detail {
        font-size: 12px;

        .child-product-spec {
          font-size: 12px;
          color: #999;
          margin-top: 3px;
        }
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .total-info {
      color: #999;
      font-size: 14px;
    }
  }

  .order-detail {
    padding: 0 20px;

    .detail-item {
      margin-bottom: 12px;
      line-height: 20px;
      display: flex;

      .label {
        color: #606266;
        min-width: 100px;
        text-align: right;
        margin-right: 10px;
      }

      .value {
        flex: 1;
        color: #333;
      }

      .copy-btn {
        margin-left: 10px;
        color: #333;
        background-color: #fff;
        border-color: #dcdfe6;
        padding: 4px 10px;
        font-size: 12px;
      }
    }

    .product-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 5px;
    }

    .product-container {
      display: flex;
      align-items: center;
      margin-top: 5px;

      .product-img {
        width: 50px;
        height: 50px;
        object-fit: cover;
        border-radius: 4px;
        margin-right: 10px;
      }

      .product-name {
        flex: 1;
        font-size: 14px;
      }

      .product-tag {
        font-size: 12px;
        color: #fff;
        background-color: #67c23a;
        padding: 2px 6px;
        border-radius: 2px;
        margin-left: 10px;
      }
    }
  }

  .shipping-info {
    margin-top: 20px;
    border-top: 1px dashed #ebeef5;
    padding-top: 15px;

    .shipping-select {
      width: 100%;
    }

    .tracking-input {
      width: 100%;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;

    .footer-left {
      text-align: left;

      .chat-btn {
        color: #333;
        background-color: #fff;
        border-color: #dcdfe6;
      }
    }

    .footer-right {
      text-align: right;
    }
  }
}

.white-bg {
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: 800;
}

.product-name-ellipsis {
  width: 160px;
  /* 固定宽度 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}

.red-star {
  color: #ff4444;
  margin-right: 4px;
}
</style>
